angular.module('bmsApp.crm.email').controller('EmailViewCtrl', function ($state,
																		 $scope,
																		 EmailSvc) {

	$scope.emailViewCtrl = {
		email: {
			id: $state.params.emailId
		},
		loading: false,
		init: function () {
			$scope.emailViewCtrl.loading = true;
			EmailSvc.read($scope.emailViewCtrl.email.id).then(function (response) {
				angular.extend($scope.emailViewCtrl.email, response.data.email);
				$scope.emailViewCtrl.loading = false;
			});
		}
	};

});
